type NitoelEnv = "prod" | "pre" | "stg" | "dev" | "local" | "unknown";
export const getNitoelEnv = (): NitoelEnv => {
  const domain = window.location.hostname;
  switch (domain) {
    case "supplier.nitoel.com":
      return "prod";
    case "pre.supplier.nitoel.net":
      return "pre";
    case "stg.supplier.nitoel.net":
      return "stg";
    case "dev.supplier.nitoel.net":
      return "dev";
    case "127.0.0.1":
      return "local";
    case "localhost":
      return "local";
    default:
      return "unknown";
  }
};
